export default {
  state: {
    keywords: ""
  },
  mutations: {
    setKeywords(state, payload) {
      state.keywords = payload;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/list.js